import { render, staticRenderFns } from "./ButtonsGrid.vue?vue&type=template&id=57ce80fa&scoped=true"
import script from "./ButtonsGrid.vue?vue&type=script&lang=js"
export * from "./ButtonsGrid.vue?vue&type=script&lang=js"
import style0 from "./ButtonsGrid.vue?vue&type=style&index=0&id=57ce80fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ce80fa",
  null
  
)

export default component.exports